import { FC, useCallback, useEffect, useRef, useState } from 'react';

import { maybeCall } from 'src/utils/common';
import { AlertContext, emptyAlert } from './context';
import { AlertType } from './types';

export const AlertProvider: FC = ({ children }) => {
  const [alert, setAlert] = useState<AlertType>(emptyAlert);
  const [isAlertOpen, setAlertOpen] = useState(false);

  const onCloseAlert = useCallback(() => {
    setAlertOpen(false);
    maybeCall(alert.onClose);
    setAlert(emptyAlert);
  }, [alert]);

  const onOpenAlert = useCallback((alert: Partial<AlertType>) => {
    setAlert({
      message: alert.message || emptyAlert.message,
      onClose: alert.onClose,
      title: alert.title || emptyAlert.title,
      type: alert.type || emptyAlert.type,
    });
    setAlertOpen(true);
  }, []);

  const timeouts = useRef<any[]>([]);

  const onOpenAlertDelayed = useCallback(
    (alert: Partial<AlertType>, delayMs = 0) => {
      const timeoutId = setTimeout(() => {
        onOpenAlert(alert);
      }, delayMs);

      timeouts.current = [...timeouts.current, timeoutId];
    },
    [],
  );

  useEffect(
    () => () => {
      timeouts.current.forEach((i) => {
        clearTimeout(i as any);
      });
    },
    [],
  );

  return (
    <AlertContext.Provider
      value={{
        alert,
        isAlertOpen,
        onCloseAlert,
        onOpenAlert,
        onOpenAlertDelayed,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};
